export default __webpack_public_path__ + "src/assets/icn-info-blue.8b89a7dbccf044384c9e17c8a2e1735e.svg";